import { FC } from "react";
import VehicleInstanceDataManager from "./vehicleInstanceDataManager";
import VehicleModelData from "./vehicleModelData";
import { Vehicle } from "../../types/appTypes";
import Details from "../detailsList";
import _t from "../../lang/translate";

type Props = {
  vehicle: Vehicle | null;
  showAdditionalData?: boolean;
  showDMRAlerts?: boolean;
  motorAtlasIdCallback?: () => void;
  loadingMotorAtlasCatalog?: boolean;
};


const VehicleInfo: FC<Props> = ({ vehicle, showAdditionalData, showDMRAlerts, motorAtlasIdCallback, loadingMotorAtlasCatalog }) => {
  const searchHint = vehicle?.searchHint

  return (
    <>
      <Details>
        <Details.Item
          label={"Søge hint"}
          value={`${searchHint?.model ?? ""} ${searchHint?.variant ?? ""}`}
        />
      </Details>
      <VehicleModelData
        vehicle={vehicle}
        showAdditionalData={showAdditionalData}
        showDMRAlerts={showDMRAlerts}
        motorAtlasIdCallback={motorAtlasIdCallback}
        loadingMotorAtlasCatalog={loadingMotorAtlasCatalog}
      />
      <VehicleInstanceDataManager vehicle={vehicle} showDMRAlerts={showDMRAlerts} />
    </>
  );
};

export default VehicleInfo;
